<template>
  <div v-if="trialDays > 0" class="billing-trial-header">
    <div class="flex items-center justify-center w-full h-12">
      <ThemeImage :icon="imageNames.CLOCK_ICON" width="20" height="20" />
      <span class="text-sm ml-1"
        >Your free trial will expire in <b>{{ trialDays }} day{{ trialDays === 1 ? '' : 's' }}</b></span
      >
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { imageNames } from '@/javascript/imageConstants';
import ThemeImage from '@/components/custom/ThemeImage.vue';

const props = defineProps({
  trialDays: {
    type: Number,
    required: true,
    default: 0,
  },
});
</script>

<style scoped>
.billing-trial-header {
  background-color: var(--layout-bg-color);
  position: fixed;
  left: 225px;
  width: calc(100vw - 225px);
  top: 50px;
  z-index: 20;
}
</style>
